// Constants
import { DRAWING_TOOLBAR_STROKE_COLOR_UPDATED_EVENT } from '../drawingEditor/drawingEditorConstants';
import { DRAWING_COLOR_KEY } from '../drawingEditor/useDrawingEditorToolbarState';
import globalLogger from '../../../logger/logger';

const logger = globalLogger.createChannel('element.drawing');

/**
 * Updates the drawing tool's stroke color directly using localStorage
 * Also triggers a custom event to notify the drawing editor
 */
export const updateDrawingToolStrokeColor = (color: string): void => {
    // Update localStorage directly (this is how the drawing tool state persists)
    try {
        // The useLocalStorage hook expects JSON-encoded values
        const jsonColor = JSON.stringify(color);
        localStorage.setItem(DRAWING_COLOR_KEY, jsonColor);

        // Dispatch a specific event for drawing stroke color updates
        // This allows the drawing editor to listen for and react to color changes
        window.dispatchEvent(
            new CustomEvent(DRAWING_TOOLBAR_STROKE_COLOR_UPDATED_EVENT, {
                detail: { color },
            }),
        );
    } catch (e) {
        logger.warn('Failed to update drawing color in localStorage', e);
    }
};
